<template>
  <rv-year :disabled="disabled" :name="name" :label="label" :validation-rule="validationRule" v-model="data" v-on:input="update"/>
</template>

<script>
import RvYear from '../RvYear'

export default {
  props: ['value', 'disabled'],
  inject: ['$validator'],
  components: { RvYear },
  data() {
    return {
      label: 'How long is the likely delay? (in months)',
      name: 'outgoing-delay',
      validationRule: {
        required: true,
        between: [0, 60]
      },
      data: this.value
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    }
  },
  watch: {
    value: function(val) {
      this.data = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modules/inputs/additional-outgoing-fees/OutgoingDelay.vue